import React from 'react';
import { ArrowUpRight } from 'lucide-react';

/**
 * One-tap "Open <page> →" buttons rendered under an assistant navigation
 * answer. Clicking navigates the app to the real in-app route and closes the
 * Astrid drawer. Routes are already RBAC-filtered by the backend
 * (describe_page / build_deep_link), so anything here is safe for this user.
 * Persisted on the message (like suggested_actions) so they survive reload.
 */
const buildTarget = (action) => {
  let route = action.route || '';
  if (!route) return '';
  const filters = action.filters || {};
  const keys = Object.keys(filters).filter((k) => filters[k] != null && filters[k] !== '');
  if (keys.length) {
    const qs = keys.map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(filters[k])}`).join('&');
    route += (route.includes('?') ? '&' : '?') + qs;
  }
  return route;
};

export const NavDeepLinks = ({ actions = [] }) => {
  const items = (actions || []).filter((a) => a && a.route);
  if (!items.length) return null;

  const go = (action) => {
    const target = buildTarget(action);
    if (!target) return;
    // Let the Astrid mount close the drawer + SPA-navigate (no full reload).
    window.dispatchEvent(new CustomEvent('ai-agent:navigate', { detail: { route: target } }));
  };

  return (
    <div data-testid="ai-agent-nav-actions" className="mt-3 not-prose flex flex-wrap gap-1.5">
      {items.map((a, i) => (
        <button
          key={`${a.route}_${i}`}
          type="button"
          onClick={() => go(a)}
          data-testid="ai-agent-nav-action-btn"
          className="inline-flex items-center gap-1 rounded-lg bg-emerald-600 px-3 py-1.5 text-[12px] font-semibold text-white transition-colors hover:bg-emerald-700"
        >
          {a.label || 'Open this page →'}
          <ArrowUpRight className="h-3.5 w-3.5" />
        </button>
      ))}
    </div>
  );
};

export default NavDeepLinks;
